import React, { useEffect, useRef, useState } from "react";
import './styles.scss'

interface IImageLazyProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string
}

export const ImageLazy = ({ src, alt = "", ...props }: IImageLazyProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const [loaded, setLoaded] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (!ref.current) return

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true)
        observer.disconnect()
      }
    }, {
      rootMargin: "200px", // Start loading 200px before it appears
    })

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [])

  return (
    <div ref={ref}>
      {isVisible &&
        <img
          src={src}
          alt={alt}
          className='image-lazy'
          data-loaded={loaded}
          onLoad={() => setLoaded(true)}
          loading="lazy"
          {...props} />}
    </div>
  )
}